import api from "@/lib/api";
import type { ProvisioningJob } from "@/lib/forex-api";

export type CollectorManagedJob = Omit<ProvisioningJob, "account_role" | "target_type" | "terminal_id" | "enable_live_order_send" | "enable_command_poll"> & {
  account_role: "collector";
  target_type: "quote_collector";
  terminal_id: string | null;
  enable_live_order_send: false;
  enable_command_poll: false;
  enable_execution_quote_push: false;
};
export interface CollectorRetirementRequest { job_id: string; expected_revision: number }
export interface CollectorMaintenanceJobRequest {
  credential_binding_id: string;
  expected_credential_version: number;
  preferred_runner_id: string | null;
}
export interface CollectorCredentialsRequest {
  login: string;
  password: string;
  consent_version: "collector-hosting-v1";
  expected_credential_version: number | null;
}
export interface CollectorCredentialView { credential_binding_id: string; version: number; status: "active" }
export interface CollectorGrantRevokeView { grant_id: string; revision: number; status: "revoked" }
const prefix = "/quantum/business/forex/collectors";
const resource = (collectorId: string) => `${prefix}/${encodeURIComponent(collectorId)}`;
const headers = (operationKey: string) => ({ headers: { "Idempotency-Key": operationKey } });

export const collectorLifecycleApi = {
  async grant(collectorId: string, body: {source_master_account_id:string;expected_source_credential_revision:number;expected_revision:number;consent_version:"collector-hosting-v1"}, operationKey:string): Promise<{grant_id:string;collector_credential_binding_id:string;credential_revision:number;status:string}> {
    const response=await api.post<{data:{grant_id:string;collector_credential_binding_id:string;credential_revision:number;status:string}}>(`${resource(collectorId)}/credential-grants`,body,headers(operationKey));
    return response.data.data;
  },
  async retire(collectorId: string, body: CollectorRetirementRequest, operationKey: string): Promise<CollectorManagedJob> {
    const response = await api.post<{ data: CollectorManagedJob }>(`${resource(collectorId)}/retirement`, body, headers(operationKey));
    return response.data.data;
  },
  async createJob(collectorId: string, body: CollectorMaintenanceJobRequest, operationKey: string): Promise<CollectorManagedJob> {
    const response = await api.post<{ data: CollectorManagedJob }>(`${resource(collectorId)}/provisioning-jobs`, body, headers(operationKey));
    return response.data.data;
  },
  async revokeGrant(collectorId: string, grantId: string, expectedRevision: number, operationKey: string): Promise<CollectorGrantRevokeView> {
    const response = await api.post<{ data: CollectorGrantRevokeView }>(`${resource(collectorId)}/credential-grants/${encodeURIComponent(grantId)}/revoke`, { expected_revision: expectedRevision }, headers(operationKey));
    return response.data.data;
  },
  async storeCredentials(collectorId: string, body: CollectorCredentialsRequest, operationKey: string): Promise<CollectorCredentialView> {
    const response = await api.put<{ data: CollectorCredentialView }>(`${resource(collectorId)}/credentials`, body, headers(operationKey));
    return response.data.data;
  },
};
